const {FoxThemeStyles, FoxThemeScripts} = window
class QuickView {
	constructor() {
		this.modal = null

		addEventDelegate({
			selector: '[data-product-quickview]',
			handler: (e, target) => {
				e.preventDefault()
				this.target = target
				target.classList.add('btn--loading')
				const productHandle = target.dataset.productQuickview;
				const selectedVariantId = target.dataset.selectedVariantId;
				let finalHandle = productHandle;
				if ( selectedVariantId != null ) {
					finalHandle = finalHandle + '?variant=' + selectedVariantId;
				}
				
				if (finalHandle) this.fetchHtml(finalHandle)
			}
		})

		window.FoxThemeEvents.subscribe(`ON_ITEM_ADDED`, () => {
			if (this.modal) this.modal.hide()
		})
	}

	fetchHtml(productHandle) {

		try {
			if ( window.lillapAnalytics ) {
			  window.lillapAnalytics.trackQUICKView();
			}
		  } catch ( gaerror ) {
			// do nothing
		  }

		let preSelectColor = false;
		let variantColorName;
		if ( productHandle.includes('?variant-color=')) {
			let infoSplit = productHandle.split('?variant-color=');
			productHandle = infoSplit[0];
			variantColorName = infoSplit[1].replaceAll("_", " ");
			preSelectColor = true;
		}
		loadAssets([FoxThemeStyles.product], 'quick-view-assets')
		fetchSection('product-quickview', {url: `${window.FoxThemeSettings.base_url}products/${productHandle}`}).then(html => {
			
			this.modal = html.querySelector('modal-dialog')
			const firstModel = html.querySelector('product-model')
			this.mediaGallery = this.modal.querySelector('media-gallery')
			document.body.appendChild(this.modal)
			loadAssets([FoxThemeScripts.productMedia, FoxThemeScripts.variantsPicker], 'variants-picker', () => {
				this.modal && this.modal.show(this.target)
				if (this.mediaGallery) {
					const thumb = this.mediaGallery.querySelector('[id^="GalleryThumbnails"]')
					if (thumb) thumb.update()
					this.mediaGallery.update()
				}
				if (Shopify && Shopify.PaymentButton) {
					Shopify.PaymentButton.init()
				}
				this.target.classList.remove('btn--loading')
				this.handleClose()
				__reInitTooltip(this.modal);
				if ( preSelectColor ) {
					this.handleColorSelection(variantColorName)
				}
			})
			if (firstModel) {
				loadAssets([FoxThemeScripts.productModel, 'https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css'], 'product-model-assets')
			}
		})
			.catch(console.error)
	}

	handleClose() {
		if (!this.modal) return
		this.modal.addEventListener('close', () => {
			this.modal.remove()
		})
	}

	handleColorSelection(variantColor) {
		if (!this.modal) return
		
		const container = document.querySelector('.f-product-quickview');
		if ( container != null ) {
			const colorContainer = container.querySelector('.variant-picker__color');
			if ( colorContainer != null ) {
				const allOptions = colorContainer.querySelectorAll(".variant-picker__option");
				for ( let option of allOptions ) {
					const colorName = option.getAttribute('data-value')
					if ( colorName == variantColor ) {
						const radio = option.querySelector('input')
						radio.click()
						break
					}
				}
			}
		}
	}
}

new QuickView()
